import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { X } from 'lucide-react';
import api from '../../../utils/authUtils';
import { Overlay, Modal, ModalTitle, ModalField, ModalActions, Input, Message, Button } from './ui';
import { eventNameFor } from '../../../utils/eventName';

// For a decline that reached the organizers another way (usually a reply to
// the invitation email): records it like the speaker's own decline on the
// Respond page - every role/session still open at this event, with the
// replacement they suggested, if any - which also stops the reminders.
// `invite` is a row of /api/cms/invite-reminders/pending.
const MarkDeclinedModal = ({ invite, onClose, onDone }) => {
  const intl = useIntl();
  const t = (id, def, values) => intl.formatMessage({ id, defaultMessage: def }, values);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const event = eventNameFor(intl.locale, invite.eventName, invite.eventNameEN);

  const submit = async e => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.post(`/api/cms/speaker-profiles/${invite.speakerProfileId}/events/${invite.eventId}/decline`, {
        replacementName: name.trim() || null, replacementEmail: email.trim() || null,
      });
      onDone?.();
      onClose();
    } catch (err) {
      setError(typeof err.response?.data === 'string' && err.response.data
        ? err.response.data : t('inviteReminders.decline.error', 'Could not record the decline.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Overlay onClick={() => !busy && onClose()}>
      <Modal as="form" onSubmit={submit} onClick={e => e.stopPropagation()} style={{ maxWidth: '32rem' }}>
        <ModalTitle><X size={18} color="#991b1b" />
          <FormattedMessage id="inviteReminders.decline.title" defaultMessage="Mark {name} as declined?" values={{ name: invite.name }} />
        </ModalTitle>
        <p style={{ margin: '0 0 1rem', fontSize: '.88rem', color: '#334155', lineHeight: 1.5 }}>
          <FormattedMessage id="inviteReminders.decline.intro"
            defaultMessage="Use this when they told you another way – for example by replying to the email. Everything they were invited for at {event} is marked as declined and no more reminders are sent. They are not notified."
            values={{ event: <strong>{event}</strong> }} />
        </p>
        <ModalField>
          <FormattedMessage id="inviteReminders.decline.name" defaultMessage="Suggested replacement – name (optional)" />
          <Input value={name} maxLength={200} onChange={e => setName(e.target.value)} />
        </ModalField>
        <ModalField>
          <FormattedMessage id="inviteReminders.decline.email" defaultMessage="Suggested replacement – email (optional)" />
          <Input type="email" value={email} maxLength={200} onChange={e => setEmail(e.target.value)} />
        </ModalField>
        {error && <Message error>{error}</Message>}
        <ModalActions>
          <Button type="button" secondary disabled={busy} onClick={onClose}><FormattedMessage id="speakerMgmt.confirm.cancel" defaultMessage="Cancel" /></Button>
          <Button type="submit" danger disabled={busy}><X size={15} /><FormattedMessage id="inviteReminders.decline.submit" defaultMessage="Mark as declined" /></Button>
        </ModalActions>
      </Modal>
    </Overlay>
  );
};

export default MarkDeclinedModal;
